<template>
  <div class="row" v-if="playerPropsCount">
    <div class="col-6 pe-0"><PlayerPic></PlayerPic></div>
    <div class="col-6 ps-0">
      <ul class="list-group">
        <li class="list-group-item bg-grad-green">
          <span class="fw-bold">{{ player.name }}</span>
        </li>
      </ul>

      <ul class="list-group">
        <li
          class="list-group-item bg-grad-orange padding5"
          v-for="s in player.stats"
          :key="s"
        >
          {{ s }}
        </li>
        <li
          class="list-group-item fw-bold text-danger bg-grad-orange"
          v-if="player.team_id"
        >
          SOLD!
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import PlayerPic from "../images/PlayerPic.vue";
import { useStore } from "@/store/index";
const store = useStore();
const player = ref({});
onMounted(() => {
  setTimeout(() => {
    fetchPlayer();
  }, 1000);
});
const fetchPlayer = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("id", store.viewer_live_player_id);
  player.value = players[0];
  setupPlayerListner();
};
const playerPropsCount = computed(() => {
  return Object.keys(player.value).length;
});
const setupPlayerListner = () => {
  const channels = supabase
    .channel("viewer-player-nmd32i-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "players" },
      (payload) => {
        console.log("Change received!", payload);
        if (
          payload.eventType == "UPDATE" &&
          payload.new.id == player.value.id
        ) {
          player.value = payload.new;
        }
      }
    )
    .subscribe();
};
</script>
<style scoped>
.padding5 {
  padding: 3px;
}
</style>
